export const speedoMeterColors = [
  '#FA364C',
  '#FFA360',
  '#FFC65F',
  '#A0C460',
  '#5EC665',
];
